export default build =>
    build.query({
        tagTypes: ['allTalukas'],
        keepUnusedDataFor: 30,
        query() {
            //console.log("payload",payload)            
            return {
                url: '/exam/gettaluka',
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['allTalukas']
    })
